import { Component } from '@angular/core';
import {Router} from "@angular/router";


@Component({
  selector: 'app-web',
  standalone: true,
  imports: [],
  templateUrl: './web.component.html',
  styleUrls: ['./web.component.scss']
})
export class WebComponent {
    basePath = "web";


    constructor(private router: Router) {
    }

    navigate(url: string, fragment: string) {

        this.router.navigate([url], { fragment });

    }
}
